import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

// Components
import GatsbyHead from '../../components/layout/gatsby-head';
import Layout, { Container, TwoThirds } from '../../components/layout';
import PageTitle from '../../components/page-title';
import Policy from '../../components/policy';
import Assemblies from '../../components/assemblies';
import withSplitTest from '../../components/with-split-test';

// Utils
import { extractLayoutProps } from '../../utils/layout';

export const Head = ({ data }) => <GatsbyHead pageContent={data.page} />;

const PolicyPage = ({ data }) => {
  const { page } = data;

  const { title, policy, assemblies } = page;

  return (
    <Layout {...extractLayoutProps(page, data.contentfulConfig)}>
      <article>
        <PageTitle twoThirds>
          <h1>{title}</h1>
        </PageTitle>
        <Container>
          <TwoThirds>
            <Policy {...policy} />
            <Assemblies assemblies={assemblies} />
          </TwoThirds>
        </Container>
      </article>
    </Layout>
  );
};

PolicyPage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.object,
    contentfulConfig: PropTypes.object,
  }),
};

export default withSplitTest(PolicyPage);

export const PolicyPageQuery = graphql`
  query PolicyPageTemplateQuery($contentful_id: String!) {
    page: contentfulPagePolicy(contentful_id: { eq: $contentful_id }) {
      ...PagePolicyFragment
    }
    ...NavigationFragment
  }
`;
